import React from 'react';
import cx from 'classnames';
import sortBy from 'lodash/sortBy';
import styles from './style.module.css';

export interface SubMenuItemProps {
  value: number;
  label?: string;
  action?: () => void;
  isSelected?: boolean;
  ariaLabel?: string;
}
export interface SubMenuProps {
  items: SubMenuItemProps[];
  className?: string;
  parentAriaLabel: string;
  selectedItem?: number;
}
const SubMenuItem: React.FC<SubMenuItemProps> = ({
  isSelected = false,
  children,
  ariaLabel,
  action,
}) => {
  const itemClass = cx('b--transparent pointer list flex items-center', styles.subItemsClass, {
    [styles.active]: isSelected,
    red: isSelected,
    abbey: !isSelected,
  });

  return (
    <li className={itemClass}>
      <a onClick={action} title={ariaLabel}>
        {children}
      </a>
    </li>
  );
};

export const SubMenu = ({ items, className, parentAriaLabel, selectedItem }: SubMenuProps) => {
  const subItems = sortBy(items, 'value').map(({ value, label, action }) => (
    <SubMenuItem
      key={`${value}-${label}`}
      value={value}
      isSelected={Number(value) === Number(selectedItem)}
      action={action}
      ariaLabel={`${parentAriaLabel} - ${label}`}
    >
      {label}
    </SubMenuItem>
  ));

  return (
    <div className={className}>
      <ul className="fw4 f13 pl48 pt16 pb16">{subItems}</ul>
    </div>
  );
};
